import { ContactCardBodyMediumLink, ContactCardItemContainer } from './styles';
import MailIcon from '@mui/icons-material/Mail';
import React from 'react';
import { User } from '../../../types';
import { useTheme } from '../../../hooks';

type Props = Pick<User, 'email'>;

export const ContactCardEmailItem = ({ email }: Props) => {
    const { colors } = useTheme();
    return (
        <ContactCardItemContainer>
            <MailIcon style={{ backgroundColor: colors.secondaryDark }} />
            <ContactCardBodyMediumLink href={'mailto:' + email}>{email}</ContactCardBodyMediumLink>
        </ContactCardItemContainer>
    );
};
